import React from "react"

export default function onClick(action: () => void): (e: React.MouseEvent) => void {
  return e => {
    e.stopPropagation()
    e.preventDefault()
    action()
  }
}
